import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskQueuesAddonRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-addon',
	path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
	exact: true,
};
